module.exports = __webpack_public_path__ + "static/img/r4.675632d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/r4.png
// module id = fqv5
// module chunks = 0